export default __webpack_public_path__ + "static/media/continue_on_desktop_icon.12383292.svg";